import { type SVGAttributes } from "react";

export function CurrencyIcon({ ...props }: SVGAttributes<SVGSVGElement>) {
  return (
    <svg
      fill="none"
      height="24"
      viewBox="0 0 24 24"
      width="24"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M15.274 9.70893C15.2413 8.89376 14.7848 7.18508 12.0849 7.16559C10.5001 7.15416 9.65335 7.6632 9.22843 8.24158C8.93985 8.63438 8.84158 9.2447 8.87626 9.59154C8.95452 10.3741 9.03278 11.4503 12.0262 11.9784C14.6078 12.4339 15.3913 13.1719 15.4696 14.3066C15.5437 15.3808 15 16.9907 12.1044 17.0064C9.20886 17.022 8.54365 15.0501 8.52411 14.1305"
        stroke="currentColor"
        strokeLinecap="square"
        strokeWidth="1.5"
      />
      <path
        d="M12.124 6.28931V5.28931"
        stroke="currentColor"
        strokeLinecap="square"
        strokeWidth="1.5"
      />
      <path
        d="M12.124 18.7107V17.7107"
        stroke="currentColor"
        strokeLinecap="square"
        strokeWidth="1.5"
      />
    </svg>
  );
}
